import { BoxProps } from '@chakra-ui/react';
import {
  Column,
  ColumnSizingColumn,
  RowData,
  SortingColumn,
} from '@tanstack/react-table';

export const flexProps = (column: ColumnSizingColumn): BoxProps => ({
  display: 'inline-block',
  flexGrow: column.getSize(),
  width: column.getSize() + `px`,
  flexShrink: 0,
});

export const sortableHeaderProps = <T extends RowData>(
  column: SortingColumn<T>
): BoxProps => {
  if (!column.getCanSort()) {
    return {};
  }
  return {
    as: 'button',
    textAlign: 'left',
    onClick: () => {
      column.toggleSorting();
    },
  };
};

export function getColumnName<T extends RowData>(
  column: Column<T>
): string | undefined {
  // This is a quickfix that only works as long as we specify headers as strings
  if (typeof column.columnDef.header === 'string') {
    return column.columnDef.header;
  }
  return undefined;
}
